import clsx from 'clsx';

export function MinimizeIcon({ className, ...props }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
      className={clsx(className)}
      {...props}
    >
      <path
        d="M6.66667 13.3333V9.33333H2.66667M6.66667 9.33333L2 14M9.33333 2.66667V6.66667H13.3333M9.33333 6.66667L14 2"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
